export default __webpack_public_path__ + "static/media/our-culture.f8a15614.png";